import { NavRoute } from "models/routes";
import { NavLink } from "react-router-dom";

interface Props {
	route: NavRoute;
	isActive: boolean;
	isExpanded: boolean;
	onClick?: () => void;
}

const baseClasses =
	"h-8 w-full flex items-center text-[hsl(var(--sidebar-foreground))] text-sm no-underline rounded-md transition-colors";

const activeClasses =
	"bg-primary text-primary-foreground font-medium hover:bg-primary/90";

const inactiveClasses =
	"bg-transparent hover:bg-[hsl(var(--sidebar-accent))] hover:text-[hsl(var(--sidebar-accent-foreground))]";

const NavbarRoute = (props: Props): JSX.Element => {
	const { route, isExpanded, onClick, isActive } = props;

	const renderRouteContent = () => (
		<>
			{route.icon ? (
				<div
					className="flex items-center justify-center"
					style={{ marginRight: isExpanded ? 8 : 0 }}
				>
					<route.icon className="h-4 w-4 shrink-0" />
				</div>
			) : null}
			{isExpanded ? route.title : null}
		</>
	);

	const stateClasses = isActive ? activeClasses : inactiveClasses;

	if (onClick) {
		return (
			<button
				type="button"
				onClick={onClick}
				className={`${baseClasses} ${stateClasses} border-none cursor-pointer p-0 ${
					isExpanded ? "px-2 justify-start" : "justify-center"
				}`}
			>
				{renderRouteContent()}
			</button>
		);
	}

	return (
		<NavLink
			to={route.to}
			className={({ isActive: navActive }) =>
				`${baseClasses} ${navActive ? activeClasses : inactiveClasses} ${
					isExpanded ? "px-2" : "justify-center"
				}`
			}
		>
			{renderRouteContent()}
		</NavLink>
	);
};

export default NavbarRoute;
